import { render, staticRenderFns } from "./AudienceAnalysis.vue?vue&type=template&id=25b21e42&scoped=true"
import script from "./AudienceAnalysis.vue?vue&type=script&lang=js"
export * from "./AudienceAnalysis.vue?vue&type=script&lang=js"
import style0 from "./AudienceAnalysis.vue?vue&type=style&index=0&id=25b21e42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b21e42",
  null
  
)

export default component.exports